import { HttpClient } from '@angular/common/http';
import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import { ApiErrorHandlerProvider } from '../../providers/api-error-handler/api-error-handler';
import { SearchServiceProvider } from '../../providers/search-service/search-service';

/**
 * Generated class for the FavouritesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-favourites',
  templateUrl: 'favourites.html',
})
export class FavouritesPage {

  errors: {};
  loading: boolean;
  allShops: any[] = []; 
  viewTab:any="grid";
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private apiErrorHandler: ApiErrorHandlerProvider,
    private http: HttpClient,
    private searchProvider: SearchServiceProvider
  ) {
  }

  ionViewDidLoad() {
    console.log("+++++++++");
    this.searchProvider.search(null, 'All').then((shops: any) => {
      this.getTrendingCuts().then((favouriteShop: any[]) => {
        const favouriteShopIds = new Set(favouriteShop.map(fav => fav.shop_id));
        
        const favouriteShopsOnly = shops
          .filter(shop => favouriteShopIds.has(shop.id))
          .map(shop => ({
            ...shop,
            is_favourite: true
        }));
  
        this.allShops = favouriteShopsOnly;
      });
    });
  }
  

  getTrendingCuts() {
    let tuid = localStorage.getItem('tuid');
    return new Promise((resolve, reject) => {
      this.http.get('/favourite/user/' + tuid)
        .subscribe(favouriteShop => {
          resolve(favouriteShop);
        }, error => {
          this.errors = this.apiErrorHandler.handleError(error);
        }, () => {
          this.loading = false;
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/favourites/favourites.ts